<template>
  <el-dialog :visible.sync="isPopup"
             title="规则"
             :close-on-click-modal="true"
             :before-close="close"
             :close-on-press-escape="false">
  <div class="slotRule">
    <div v-if="slotData.type==0" class="layout">
      <el-form>
        <el-form-item label="每次抽奖消耗">
          <p>{{slotData.rule.eachConsumption}}</p>
        </el-form-item>
        <el-form-item label="最多可抽奖">
          <p>{{slotData.rule.maxQuantity}}</p>
        </el-form-item>
      </el-form>
      <div class="table">
        <div class="item">
          <ul>
            <li v-for="item in nav" :style="{'width':100/nav.length+'%'}"><p>{{ item.name }}</p></li>
          </ul>
        </div>
        <div class="item" v-if="slotData.rule.probability">
          <ul v-for="(item,index) in slotData.rule.probability[0].percents">
            <li :style="{'width':100/nav.length+'%'}"><p>{{ index + 1 }}</p></li>
            <li :style="{'width':100/nav.length+'%'}">
              <p>{{ slotData.rule.probability[0].percents[index].quantity }}</p>
            </li>
            <li v-for="(subItem,i) in slotData.rule.probability.length" :style="{'width':100/nav.length+'%'}">
              <p>{{ slotData.rule.probability[i].percents[index].percent }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div v-else-if="slotData.type==1" class="layout">
      <el-form>
        <el-form-item label="骰子兑换">
          <p>{{slotData.rule.exchangeConsumption}}</p>
        </el-form-item>
      </el-form>
      <div class="flex">
        <div class="table">
          <div class="item">
            <ul>
              <li v-for="item in navArr" :style="{'width':100/navArr.length+'%'}"><p>{{ item.name }}</p></li>
            </ul>
          </div>
          <div class="item" v-if="slotData.rule.limitedDices">
            <ul v-for="(item,index) in slotData.rule.limitedDices">
              <li :style="{'width':100/navArr.length+'%'}"><p>{{ index + 1 }}</p></li>
              <li :style="{'width':100/navArr.length+'%'}">
                <p>{{findTaskName(slotData.rule.limitTaskData,item.taskId)}}</p>
              </li>
              <li :style="{'width':100/navArr.length+'%'}"><p>{{item.quantity?item.quantity:'--'}}</p></li>
              <li :style="{'width':100/navArr.length+'%'}"><p>{{item.diceNumber}}</p></li>
            </ul>
          </div>
        </div>
        <div class="table">
          <div class="item">
            <ul>
              <li v-for="item in nav" :style="{'width':100/nav.length+'%'}"><p>{{ item.name }}</p></li>
            </ul>
          </div>
          <div class="item" v-if="slotData.rule.levelQuantities">
            <ul v-for="(item,index) in slotData.rule.levelQuantities">
              <li :style="{'width':100/nav.length+'%'}"><p>{{ index + 1 }}</p></li>
              <li :style="{'width':100/nav.length+'%'}"><p>{{item.quantity}}</p></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="slotData.type==2" class="layout">
      <div class="table">
        <div class="item">
          <ul>
            <li v-for="item in navArr" :style="{'width':100/navArr.length+'%'}"><p>{{ item.name }}</p></li>
          </ul>
        </div>
        <div class="item" v-if="slotData.rule.levelsQuantity">
          <ul v-for="(item,index) in slotData.rule.levelsQuantity">
            <li :style="{'width':100/navArr.length+'%'}"><p>{{ item.level }}</p></li>
            <li :style="{'width':100/navArr.length+'%'}">
              <p>{{findTaskName(slotData.rule.limitTaskData,item.taskId)}}</p>
            </li>
            <li :style="{'width':100/navArr.length+'%'}"><p>{{item.quantity}}</p></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'slotRule',
  props: ['slotData', 'isShow'],
  data() {
    return {
      isPopup: this.isShow,
      levelData: [
        { id: 'MIN', name: '迷你' },
        { id: 'STD', name: '标准' },
        { id: 'PLA', name: '铂金' },
        { id: 'ZER', name: '巴菲特' }
      ],
      typeArr: { 0: '奖励', 1: '条件', 2: '关卡' },
      navModel: [{ name: '关卡' }, { name: '限时任务' }, { name: '积分奖励' }],
      inputData: {},
    }
  },
  computed: {
    nav: {
      get() {
        if (this.slotData.type == 0) {
          let nav = [{ name: '序号' }, { name: '积分奖励' }], newNav = []
          for (const i in this.levelData) {
            newNav.push({
              name: this.levelData[i].name + '中奖概率（%）'
            })
          }
          nav = nav.concat(newNav)
          return nav
        } else if (this.slotData.type == 1) {
          let nav = [{ name: '关卡' }, { name: '积分奖励' }]
          return nav
        }
      }
    },
    navArr: {
      get() {
        if (this.slotData.type == 1) {
          let nav = this.navModel, newNav = [{ name: '完成后可兑换骰子数' }]
          nav = nav.concat(newNav)
          return nav
        }else if (this.slotData.type == 2){
          return this.navModel
        }
      }
    }
  },
  methods:{
    findTaskName(data, taskId) {
      let name = '--'
      for (const i in data){
        if (data[i].taskId == taskId) name = data[i].taskName
      }
      return name
    },
    close() {
      this.isPopup = false
      this.$emit('changeSlotRule', this.isPopup)
    },
  }
}
</script>

<style>
.slotRule .el-form-item{
  margin-bottom: 0;
}
.slotRule .flex{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.slotRule .table {
  border: solid 1px #ddd;
  border-bottom: none;
  margin: 10px 0 30px;
}
.slotRule .flex .table:first-child{
  width: 58%;
}
.slotRule .flex .table:last-child{
  width: 38%;
}
.slotRule .table .item:first-child{
  background: #f7f7f7;
}
.slotRule .table ul {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: solid 1px #ddd;
}
.slotRule .table li {
  border-right: solid 1px #ddd;
  list-style: none;
  position: relative;
}
.slotRule .table li:last-child {
  border-right: none;
}
.slotRule .table li p{
  overflow: hidden;
  display: block;
  font-size: 14px;
  color: #606266;
  padding: 0 10px;
  line-height: 40px;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  position: relative;
}
</style>
